/* eslint-disable react/forbid-prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Switch, Divider, Select } from 'antd';

import './SendRfq.scss';
import SendRfqHOC from './SendRfqHOC';

class SendRfq extends PureComponent {
  static propTypes = {
    options: PropTypes.any.isRequired,
    newRfq: PropTypes.any.isRequired,
    selectedRfq: PropTypes.any.isRequired,
    onRadioChange: PropTypes.func.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    closeRfqModal: PropTypes.func.isRequired,
    closeProcGroupModal: PropTypes.func.isRequired,
    modalRfqOpen: PropTypes.bool.isRequired,
    modalProcGroupVisible: PropTypes.bool.isRequired,
    handleOkRfq: PropTypes.func.isRequired,
  };

  render() {
    const {
      options,
      newRfq,
      selectedRfq,
      onRadioChange,
      onSelectChange,
      closeRfqModal,
      closeProcGroupModal,
      modalRfqOpen,
      modalProcGroupVisible,
      handleOkRfq,
    } = this.props;

    return (
      <React.Fragment>

        <Modal
          title="Send RFQ"
          visible={modalRfqOpen}
          onOk={handleOkRfq}
          onCancel={closeRfqModal}
          footer={[
            <Button key="back" onClick={closeRfqModal}>
              Return
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!newRfq && !selectedRfq}
              onClick={handleOkRfq}
            >
              Proceed
            </Button>,
          ]}
        >
          <Switch onClick={onRadioChange} checked={newRfq} /> Create a new RFQ
          for this solicitation
          <Divider plain>Or</Divider>
          <p>Select an Existing RFQ</p>
          <Select
            value={selectedRfq}
            style={{ width: '80%' }}
            onChange={onSelectChange}
            allowClear
          >
            {options}
          </Select>
        </Modal>
        <Modal
          visible={modalProcGroupVisible}
          title='Warning'
          type='warning'
          style={{ top: '40' }}
          onOk={closeProcGroupModal}
          onCancel={closeProcGroupModal}
        >
          Government users with RFQ Capabilities must be members of a RFQ Group to submit RFQs. Please contact < a href="mailto:support@nffs.org?Subject=Registration RFQ Group" target="_top"> ICON Support</a > to be added to a RFQ Group if you are an authorized procurement officer.
        </Modal>
      </React.Fragment>
    );
  }
}

export default SendRfqHOC(SendRfq);



// WEBPACK FOOTER //
// ./src/components/Modals/SendRfq/SendRfq.jsx